import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "field" }
const _hoisted_2 = ["for"]
const _hoisted_3 = { class: "control" }
const _hoisted_4 = ["required", "name", "id", "value"]

import { computed, ref, watch } from "vue";

interface Props {
  formClass: string;
  attribute: string;
  label: string;
  modelValue?: string;
  required?: boolean;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'date-field',
  props: {
    formClass: {},
    attribute: {},
    label: {},
    modelValue: {},
    required: { type: Boolean, default: false }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const dataValue = ref(props.modelValue);

// Handle input events with proper typing
function handleInput(event: Event) {
  const target = event.target as HTMLInputElement;
  emit("update:modelValue", target.value);
}

watch(
  () => props.modelValue,
  (newVal) => {
    dataValue.value = newVal;
  }
);

const dateFieldName = computed(() => `${props.formClass}[${props.attribute}]`);
const dateFieldId = computed(() => `${props.formClass}_${props.attribute}`);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("label", {
      class: "label",
      for: dateFieldId.value
    }, _toDisplayString(__props.label), 9, _hoisted_2),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("input", {
        autocomplete: "off",
        class: "input",
        type: "date",
        required: __props.required,
        name: dateFieldName.value,
        id: dateFieldId.value,
        value: dataValue.value,
        onInput: handleInput
      }, null, 40, _hoisted_4)
    ])
  ]))
}
}

})